module.exports = __webpack_public_path__ + "static/img/logo-icon.1f086c84.svg";